import React from 'react'

interface Props {}

export const DocsCadDownloads: React.FunctionComponent<Props> = () => {
  return <div></div>
}
